import React from "react";
import './manageRole.scss';  
import DataTable from "react-data-table-component";

export const RoleExpand = ({ data, updateFunctionality,viewOnly }) => {

  const columns = [
    {
      name: "Functionality",
      selector: (row) => row.functionalityDisplayName,
      cell: (row) => (
        <div className="padding-left">{row.functionalityDisplayName}</div>
      ),
      sortable: true,
    },
    {
      name: "View",
      width: "100px",
      cell: (row) => (
        <div className="text-center w-100">
          <input 
            type="checkbox" 
            disabled={!row.viewEnable||viewOnly} 
            checked={!!row.view} 
            onChange={() => updateFunctionality(row.id, "view")} 
          />
        </div>
      ),
    },
    {
      name: "Create",
      width: "100px",
      cell: (row) => (
        <div className="text-center w-100">
          <input 
            type="checkbox" 
            disabled={!row.createEnable||viewOnly} 
            checked={!!row.create} 
            onChange={() => updateFunctionality(row.id, "create")} 
          />
        </div>
      ),
    },
    {
      name: "Edit",
      width: "100px",
      cell: (row) => (
        <div className="text-center w-100">
          <input 
            type="checkbox" 
            disabled={!row.editEnable||viewOnly} 
            checked={!!row.edit} 
            onChange={() => updateFunctionality(row.id, "edit")} 
          />
        </div>
      ),
    },
    {
      name: "Delete",
      width: "100px",
      cell: (row) => (
        <div className="text-center w-100">
          <input 
            type="checkbox" 
            disabled={!row.deleteEnable||viewOnly} 
            checked={!!row.delete} 
            onChange={() => updateFunctionality(row.id, "delete")} 
          />
        </div>
      ),
    },
  ];

  return (
    <section className="datatable-holder">
      <DataTable
        columns={columns}
        data={data}
        noHeader
        dense
      />
    </section>
  );
};
